import React from "react";

const TextArea = ({label, labelClasses = null, formik, name}) => {

    const {handleChange, errors, touched} = formik;

    return <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-5 sl-text-left">
                              <span
                                  className={labelClasses ? labelClasses : "sl-font sl-font-medium sl-text-lg sl-text-gray-900"}
                                  dangerouslySetInnerHTML={{__html: label}}/>
        <div className="sl-flex sl-flex-col">
            <div
                className={`sl-flex sl-flex-col sl-justify-start sl-w-fill-available sl-gap-1-point-5`}>


            <textarea
                value={formik.values[name]}
                name={name}
                onChange={handleChange}
                className={`sl-input sl-modal-textarea sl-border-1 sl-shadow-xs sl-rounded-lg sl-font sl-font-normal sl-text-md sl-text-gray-base
                ${errors[name] && touched[name] ? 'sl-border-1 sl-border-solid sl-border-error-300 sl-border-radius-8' : ''} `}
            />
            </div>
            {touched[name] &&
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm">{errors[name]}</span>}
        </div>
    </div>

}


export default TextArea;